export default __webpack_public_path__ + "static/media/icon-document.03689606.svg";